import { hosts as localNewsHosts } from './hasLocalNews';

const hosts = new Set([
  ...localNewsHosts,
  'fashionunited.com.br',
  'fashionunited.com.tr',
  'fashionunited.dk',
  'fashionunited.fi',
  'fashionunited.ie',
  'fashionunited.jp',
  'fashionunited.no',
  'fashionunited.pl',
  'fashionunited.se',
]);

const hasNews = (host) => hosts.has(host);

export default hasNews;
